"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _SvgIcon = require("material-ui/SvgIcon");

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Others = function Others(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    (0, _extends3.default)({ className: "custom-icon", viewBox: "0 0 24 24" }, props),
    _react2.default.createElement("path", {
      d: "M18.464 0C19.312 0 20 .688 20 1.536v16.928c0 .848-.688 1.536-1.536 1.536H1.536A1.537 1.537 0 0 1 0 18.464V1.536C0 .688.688 0 1.536 0h16.928zM4.5 12a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3zm6 0a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3zm6 0a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3z",
      id: "a"
    })
  );
};

exports.default = Others;


//////////////////
// WEBPACK FOOTER
// ../lib/egov-ui-kit/custom-icons/others.js
// module id = ../lib/egov-ui-kit/custom-icons/others.js
// module chunks = 504